
function Oop () {

}
Oop.extend = function (Child, Parent) {
  Child.prototype = Oop.inherit(Parent.prototype);
  Child.prototype.constructor = Child;
  Child._parent = Parent.prototype;
};
Oop.inherit = function (proto) {
  function F () {}
  F.prototype = proto;
  return new F();
};
Oop.borrow = function (Child, Parent, funcList) {

    for (var index = 0; index < funcList.length; index++) {

        var funcName = funcList[index];

        if (Parent.prototype.hasOwnProperty(funcName)) {

            Child.prototype[funcName] = Parent.prototype[funcName];
        }
    }
};

module.exports = Oop;
